import { useTheme } from '../../contexts/ThemeContext'

interface HeaderProps {
  onAboutClick?: () => void
}

export function Header({ onAboutClick }: HeaderProps) {
  const { theme, toggleTheme } = useTheme()

  return (
    <header className="bg-[var(--bg-secondary)] border-b border-[var(--border-color)] px-3 sm:px-4 py-2 sm:py-3">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-2 sm:gap-3">
          <div className="w-8 h-8 sm:w-10 sm:h-10 bg-[var(--accent)] rounded-lg flex items-center justify-center">
            <span className="text-xl sm:text-2xl font-bold text-white">R</span>
          </div>
          <h1 className="text-lg sm:text-xl font-bold text-[var(--text-primary)]">
            RADIO NATKA
          </h1>
        </div>

        <div className="flex items-center gap-2">
          {onAboutClick && (
            <button
              onClick={onAboutClick}
              className="px-3 py-2 rounded-lg bg-[var(--bg-tertiary)] hover:bg-[var(--bg-primary)] transition-colors active:scale-95 text-sm font-medium text-[var(--text-secondary)]"
            >
              אודות
            </button>
          )}
          <button
            onClick={toggleTheme}
            className="p-2 rounded-lg bg-[var(--bg-tertiary)] hover:bg-[var(--bg-primary)] transition-colors active:scale-95"
            aria-label="Toggle theme"
          >
            <span className="text-lg sm:text-xl">
              {theme === 'dark' ? '☀️' : '🌙'}
            </span>
          </button>
        </div>
      </div>
    </header>
  )
}
